import clickLogin from "./click.login.js";
const install = function (Vue) {
  Vue.directive("click-login", clickLogin);
};
export default install;
